import solutiLogo from '../../assets/images/certificates/birdid.svg';
import localLogo from '../../assets/images/certificates/local.png';
import manualLogo from '../../assets/images/certificates/manual.png';
import biosignerLogo from '../../assets/images/certificates/biosigner.png';
import validLogo from '../../assets/images/certificates/vidaas.png';
import safewebLogo from '../../assets/images/certificates/safeid.png';
import certiSignLogo from '../../assets/images/certificates/certisign.png';
import evalLogo from '../../assets/images/certificates/eval.png';
import dinamoLogo from '../../assets/images/certificates/dinamo.png';
import remoteIdLogo from '../../assets/images/certificates/remoteid.png';
import { Yup } from '../../helpers/Yup';

// vou deixar aqui por enquanto pq sei que vou precisar depois
// import teladocLogo from '../../assets/images/certificates/vidaas.png';

export enum CERTIFICATES {
  TELADOC = 'TELADOC',
  SOLUTI = 'SOLUTI',
  SAFEWEB = 'SAFEWEB',
  VALID = 'VIDAAS',
  CERTISIGN = 'CERTISIGN',
  LOCAL = 'LOCAL',
  MANUAL = 'MANUAL',
  LACUNA = 'LACUNA',
  NOT_DEFINED = 'SEM_REGISTRO',
  // utilizar somente no caso do ultimo metodo assinatura
  SAFEID = 'SAFEID',
  EVAL_CONTEXT = 'EVAL_CONTEXT',
  DINAMO = 'DINAMO',
  DINAMO_UNIMEDBH = 'DINAMO_UNIMEDBH',
  REMOTE_ID = 'CERTISIGN_REMOTE_ID',
  LACUNA_MV_BIOSIGNER = 'LACUNA_MV_BIOSIGNER',
}

export type CLOUD_CERTIFICATES =
  | CERTIFICATES.SAFEWEB
  | CERTIFICATES.SOLUTI
  | CERTIFICATES.CERTISIGN
  | CERTIFICATES.DINAMO
  | CERTIFICATES.DINAMO_UNIMEDBH
  | CERTIFICATES.REMOTE_ID
  | CERTIFICATES.LACUNA_MV_BIOSIGNER;

export interface Certificate {
  name: string;
  imagePath: string;
  value: CERTIFICATES;
  certifierStatus: CERTIFIER_STATUS;
  description: string | null;
}

export enum CERTIFIER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PARTIALLY_ACTIVE = 'PARTIALLY_ACTIVE',
  NOT_APPLICABLE = 'N/A',
  RECENT_ERROR = 'RECENT_ERROR',
}

// A certificadora está instável quando explicitamente "instável" (PARTIALLY_ACTIVE) ou
// "indisponível" (INACTIVE). Qualquer outro valor é tratado como estável e libera a assinatura
// digital — em especial "N/A" (NOT_APPLICABLE), que a API retorna para certificadoras saudáveis.
export const isCertifierUnstable = (certifierStatus?: CERTIFIER_STATUS | null): boolean =>
  certifierStatus === CERTIFIER_STATUS.PARTIALLY_ACTIVE || certifierStatus === CERTIFIER_STATUS.INACTIVE;

// deixei comentado até ir implementando cada serviço de assinatura
export const certificates: Array<Certificate> = [
  // {
  //   name: 'Teladoc',
  //   imagePath: teladocLogo,
  //   value: CERTIFICATES.TELADOC,
  // },
  {
    name: 'Dinamo',
    imagePath: dinamoLogo,
    value: CERTIFICATES.DINAMO,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Dinamo Unimed BH',
    imagePath: dinamoLogo,
    value: CERTIFICATES.DINAMO_UNIMEDBH,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Soluti',
    imagePath: solutiLogo,
    value: CERTIFICATES.SOLUTI,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Safeweb',
    imagePath: safewebLogo,
    value: CERTIFICATES.SAFEWEB,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Valid',
    imagePath: validLogo,
    value: CERTIFICATES.VALID,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Eval',
    imagePath: evalLogo,
    value: CERTIFICATES.EVAL_CONTEXT,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'CertiSign',
    imagePath: certiSignLogo,
    value: CERTIFICATES.CERTISIGN,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'CertiSign',
    imagePath: remoteIdLogo,
    value: CERTIFICATES.REMOTE_ID,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Certificado </br> A1 ou A3',
    imagePath: localLogo,
    value: CERTIFICATES.LOCAL,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'Assinar </br> e carimbar',
    imagePath: manualLogo,
    value: CERTIFICATES.MANUAL,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
  {
    name: 'MV Biosigner - Grupo Santa Joana',
    imagePath: biosignerLogo,
    value: CERTIFICATES.LACUNA_MV_BIOSIGNER,
    certifierStatus: CERTIFIER_STATUS.NOT_APPLICABLE,
    description: null,
  },
];

export interface AuthCertificateData {
  email: string;
  otp: string;
  pin: string;
}

export const AuthCertificateWithLoginSchema = Yup.object().shape({
  email: Yup.string().required('Insira um e-mail válido').email('Insira um e-mail válido'),
  pin: Yup.string().required('Insira um pin válido'),
  otp: Yup.string().required('Insira um token válido'),
});
